export default "__VITE_ASSET__bab4b344__"